import React from "react";
import { ErrorMessage } from "formik";

import classes from "./FormFieldError.module.scss";

type ErrorMessageProps = {
  name: string;
};

const FormFieldError = (props: ErrorMessageProps) => {
  // return <small style={{ color: "#DF1E1E", fontSize: 12 }}>{props.children}</small>;
  return <ErrorMessage name={props.name} component="span" className={classes.errorMessage} />;
};

export default FormFieldError;
